import { ApiGWCaller } from "@warda/library-ui/contexts/ApiGWCaller";
import getErrorMsg from "@warda/library-ui/utils/getErrorMsg";
import apiUrls from "./apiUrlsSharePage";
import { BASE_URL } from "../constants/keys";
import { SEARCH_FILES_RESULT_ERROR, normalizeMediaLibrary, composeFolderPath, } from "./fetchesApiMediaLibrary";
import { SearchMode, } from "../interfaces";
import { getAccessCodeToken, getSharePageAuthorizationHeaders, } from "../components/AreaSharepage/accessCodeUtil";
import { fetchAnonymous } from "./fetchesApiAnonymous";
import getNormalizedItems from "../utils/es/getNormalizedItems";
export const doSharePageLogin = async ({ pageCode, password, }) => {
    const data = {
        pageCode,
        password,
    };
    const response = await ApiGWCaller({ baseUrl: BASE_URL }).doCall({
        ...apiUrls.login,
        data,
        withCredentials: false,
    });
    return response;
};
export const SharePageSearchFiles = async ({ area, hrch, prnt, searchMode, searchEsFolder, searchEsMedia, }) => {
    try {
        const accessCode = getAccessCodeToken();
        const { url, method } = apiUrls.searchFiles;
        const payload = {
            accessCodeToken: accessCode,
            searchMode,
            folder: searchEsFolder,
            media: searchEsMedia,
            parentFolder: undefined,
            hierarchyId: undefined,
        };
        if (searchMode === SearchMode.DEFAULT &&
            hrch !== undefined &&
            prnt !== undefined) {
            payload.parentFolder = {
                hierarchyId: hrch,
                folderId: prnt,
            };
        }
        if (searchMode === SearchMode.HIERARCHY) {
            payload.hierarchyId = hrch;
        }
        const addHeaders = getSharePageAuthorizationHeaders();
        const res = await fetchAnonymous({
            url: url(),
            method,
            jsonBody: payload,
            addHeaders,
        });
        return normalizeMediaLibrary({ area, res });
    }
    catch (err) {
        const errMsg = await getErrorMsg(err);
        return { ...SEARCH_FILES_RESULT_ERROR, error: errMsg, status: err === null || err === void 0 ? void 0 : err.status };
    }
};
export const getSharePageFilePath = async (area, file) => {
    const accessCode = getAccessCodeToken();
    const { url, method } = apiUrls.searchFiles;
    const hrch = file.data.hierarchyId;
    const prnt = "parentFolderId" in file.data && file.data.parentFolderId;
    const res = await fetchAnonymous({
        url: url(),
        method,
        jsonBody: {
            accessCodeToken: accessCode,
            searchMode: SearchMode.DEFAULT,
            parentFolder: {
                hierarchyId: hrch,
                folderId: prnt,
            },
            folder: { from: 0, size: 0 },
            media: { from: 0, size: 0 },
        },
    });
    const { items } = getNormalizedItems(res.folderLocation);
    return composeFolderPath(area, items);
};
export const getSharePageViewerBoxData = async ({ fileId, }) => {
    const apiDocId = apiUrls.boxDocumentId;
    const addHeaders = getSharePageAuthorizationHeaders();
    const { docId } = await fetchAnonymous({
        url: apiDocId.url(fileId),
        method: apiDocId.method,
        addHeaders,
    });
    const apiDocToken = apiUrls.boxDocumentToken;
    const token = await fetchAnonymous({
        url: apiDocToken.url(docId),
        method: apiDocToken.method,
        addHeaders,
    });
    return {
        docId,
        token,
    };
};
export const getSharePageUrlFirmed = async (sourceUrl) => {
    const addHeaders = getSharePageAuthorizationHeaders();
    const sourceUrlFirmed = await fetchAnonymous({
        url: sourceUrl,
        method: "GET",
        addHeaders,
    });
    return sourceUrlFirmed;
};
export const SharePageDownloadMassive = async ({ correlationId, connectionId, groups, }) => {
    if (!connectionId) {
        return { success: false, message: "Missing 'websocketId'" };
    }
    if (!correlationId) {
        return { success: false, message: "Missing 'correlationId'" };
    }
    try {
        const { url, method } = apiUrls.downloadMassive;
        const addHeaders = getSharePageAuthorizationHeaders();
        const message = await fetchAnonymous({
            url: url(),
            method,
            jsonBody: {
                correlationId,
                connectionUUID: connectionId,
                renditionGroups: groups,
            },
            addHeaders,
        });
        return { success: true, message };
    }
    catch (err) {
        const message = await getErrorMsg(err);
        return { success: false, message };
    }
};
